import { useMemo } from 'react'
import ITHeaderText from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/Components/ITHeaderText'
import InputTableLeftColumnForm from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/InputTableLeftColumnForm'
import { InputTableLeftTabsProps } from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/types'
import { FormRender } from '../../../../../../../forms/FormRenderer/types'
import TitleQuoteCost from '../../../../../../../specificComponents/TitleQuoteCosts'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { getAllCostsSell, getAllCurrencies } from '../../../../../../../utils/reducers/getters'

interface QuoteReadOnlyHeaderCostsProps extends InputTableLeftTabsProps {}

const QuoteReadOnlyHeaderCosts: React.FC<QuoteReadOnlyHeaderCostsProps> = ({ headerData, handleChange }) => {
    const { t } = useTwinTranslation()
    const dictCosts = useMemo(() => getAllCostsSell() || {}, [])
    const costs = headerData.OrderCosts
    const currencyHeaderId = headerData.CurrencyId
    const currencies = getAllCurrencies()
    const sections: FormRender<any> = []
    if (costs) {
        for (let key in costs) {
            const costSell = costs[key]
            const cost = dictCosts[costSell.CostId]
            sections.push({
                title: <TitleQuoteCost cost={cost} />,
                cols: 1,
                elements: [
                    {
                        name: 'cost_' + cost.id + '_' + key,
                        component: 'Custom',
                        render: ({ value }) => <ITHeaderText label={t('cost', 'Coste')} value={costSell?.initialPriceWithoutTax + ' ' + currencies[currencyHeaderId]?.symbolNative} />
                    },
                ]
            })
        }
    }
    return (
        <InputTableLeftColumnForm form={sections} handleChange={handleChange} headerData={headerData} />
    )
}


export default QuoteReadOnlyHeaderCosts